import { AlignmentType, Document, Header as DocXHeader, PageOrientation } from "docx";
import { Body, breakLine, C, DocXTableColumn, Header, table, text } from "./common";

const getVelicleLicense = (item: any) => {
  const isLongTerm = item.eStage === "longTerm";
  const stage = isLongTerm ? "dài hạn" : "ngắn hạn";
  const suggestion = !isLongTerm
    ? item.eSuggestion === "provide"
      ? "cấp giấy"
      : "cấp lại giấy"
    : item.eSuggestion === "provide"
    ? "cấp mới giấy"
    : item.eSuggestion === "evict"
    ? "gia hạn giấy"
    : "cấp lại giấy";

  const jsonString = item.eContent;
  const dataArray = JSON.parse(jsonString);

  const grantedAreaGenerate = (grantedArea: any | any[]) => {
    try {
      return (typeof grantedArea === "string" ? JSON.parse(grantedArea) : grantedArea)
        .map((e: any) => e.value)
        .join("; ");
    } catch (error) {
      return "";
    }
  };

  const columns: DocXTableColumn<{
    nameVehical: string;
    licensePlate: string;
    vehicleRegistrationCertificateId: string;
    certificateOfInspectionId: string;
    grantPeriod: string;
    gateAway: string;
    exit: string;
    NumberOfVehicleLicensesIssued: string;
    grantedArea: { value: string }[];
  }>[] = [
    {
      label: "STT",
      renderText: (item, index) => text((index + 1).toString()),
    },
    {
      label: "Tên phương tiện",
      renderText: (item) => text(item.nameVehical),
    },
    {
      label: "Biển kiểm soát",
      renderText: (item) => text(item.licensePlate),
    },
    {
      label: "Giấy đăng ký phương tiện/giấy phép khai thác thiết bị hàng không",
      renderText: (item) => text(item.vehicleRegistrationCertificateId),
    },
    {
      label:
        "Số chứng nhận kiểm định ATKT và BVMT giao thông cơ giới đường bộ/biên bản kiểm định đủ tiêu chuẩn khai thắc an toàn kĩ thuật, môi trường",
      renderText: (item) => text(item.certificateOfInspectionId),
    },
    {
      label: "Thời hạn cấp",
      renderText: (item) => text(item.grantPeriod),
    },
    {
      label: "Khu vực đề nghị",
      renderText: (item) => text(grantedAreaGenerate(item.grantedArea)),
    },
    {
      label: "Cổng ra/vào",
      renderText: (item) => text(item.gateAway + "; " + item.exit),
    },
  ];

  if (isLongTerm) {
    columns.push({
      label: "Số giấy phép phương tiện đã cấp",
      renderText: (item) => text(item.NumberOfVehicleLicensesIssued),
    });
  }

  // Create the document
  return new Document({
    sections: [
      {
        headers: {
          default: new DocXHeader({
            children: [
              C.row(
                C.col(undefined, Header.leftParagraph),
                C.col(undefined, Header.rightParagraph)
              ),
            ],
          }),
        },
        children: [
          C.row(
            C.col(50, [
              text(
                [
                  { text: "Số:            /VIAGS-VP" },
                  { text: `V/v cấp giấy phép hoạt động ${stage} VIAGS`, break: 1 },
                ],
                { alignment: AlignmentType.CENTER }
              ),
            ]),
            C.col(50, [Body.Date])
          ),

          breakLine(1),

          text("Kính gửi: Cảng vụ Hàng không miền Nam", { alignment: AlignmentType.CENTER }),

          breakLine(1),

          text(
            "\tCăn cứ Thông tư số 13/2019/TT-BGTVT ngày 29/03/2019 của Bộ Giao thông vận tải quy định chi tiết về chương trình an ninh hàng không và kiểm soát chất lượng an ninh hàng không Việt Nam; Căn cứ Hướng dẫn số 1458/CVMN – GSAN ngày 26/09/2022 về việc cấp thẻ, giấy phép KSAN Cảng hàng không, sân bay theo quy định."
          ),

          breakLine(1),

          text([
            {
              text: `\tCông ty TNHH MTV Dịch vụ mặt đất sân bay Việt Nam (VIAGS) kính đề nghị Cảng vụ Hàng không miền Nam (SAA) ${suggestion} phép hoạt động ${stage} cho phương tiện của VIAGS tại sân bay Tân Sơn Nhất ra/vào làm việc theo quy định `,
            },
            {
              text: "(Danh sách đính kèm).",
              italics: true,
            },
          ]),

          breakLine(1),

          text(
            "\tĐịa chỉ VIAGS: Lầu 5 Nhà điều hành Tổng công ty hàng không Việt Nam phía Nam, Sân bay Quốc tế Tân Sơn Nhất, Phường 2, Quận Tân Bình, TP. HCM."
          ),

          breakLine(1),

          text("\tMọi thông tin liên hệ: Bùi Thị Quỳnh Như."),

          breakLine(1),

          text("\tDi động: 0975021606."),

          breakLine(1),

          text("\tThư điện tử: nhubtq@viags.vn."),

          breakLine(1),

          text("\tTrân trọng cảm ơn./."),

          breakLine(1),

          C.row(C.col(50, [Body.save("Như trên;", "Lưu: VT")]), C.col(50, [Body.sign])),
        ],
      },
      {
        headers: {
          default: new DocXHeader({
            children: [
              C.row(
                C.col(undefined, Header.leftParagraph),
                C.col(undefined, Header.rightParagraph)
              ),
            ],
          }),
        },
        properties: {
          page: {
            size: {
              orientation: PageOrientation.LANDSCAPE,
            },
            margin: {
              top: 1800,
              bottom: 1800,
              left: 2160,
              right: 1440
            }
          },
        },
        children: [
          text(
            {
              text: `DANH SÁCH TRANG THIẾT BỊ ĐỀ NGHỊ CẤP GIẤY PHÉP ${stage.toUpperCase()}`,
              bold: true,
              size: 32,
            },
            { alignment: AlignmentType.CENTER }
          ),

          breakLine(1),

          text(
            {
              text: `(Kèm theo Công văn số         /VIAGS, ngày     /      /    , của  Công ty Dịch vụ Mặt đất Sân bay Việt Nam)`,
              italics: true,
              size: 32,
            },
            { alignment: AlignmentType.CENTER }
          ),

          breakLine(1),

          table({
            columns,
            data: dataArray,
          }),

          breakLine(1),

          C.row(C.col(50), C.col(50, [Body.sign])),
        ],
      },
    ],
  });
};

export default getVelicleLicense;
